export default {
  xs: '448px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1400px',
  '2xl': '1920px',
  '3xl': '2540px',
}
